import React from "react";

export const I18NContext = React.createContext({});

export const useI18N = () => React.useContext<any>(I18NContext);

export const I18NContextProvider = ({ children, t}: any) => {
  return (
    <I18NContext.Provider value={{t}}>
      {children}
    </I18NContext.Provider>
  );
};
